module.exports = __webpack_public_path__ + "img/buy_logo.2b52cf07.png";